import { subject } from "@casl/ability";
import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { useParams } from "react-router-dom";
import useUserStore from "@/modules/users/store";
import { QUERY_KEY, getJogadaDeInovacaoItem } from "../../firestore";

type TGetJogadaDeInovacaoResponse = Awaited<ReturnType<typeof getJogadaDeInovacaoItem>>;

/**
 * Get ideia from url params
 * @returns - Ideia or null if not found
 */
function useGetJogadaDeInovacaoFromUrl() {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
  const { jogadaDeInovacaoId } = useParams<{ jogadaDeInovacaoId: string }>();

  return useQuery<TGetJogadaDeInovacaoResponse, FirestoreError, TJogadaDeInovacao | null>({
    queryKey: [QUERY_KEY, jogadaDeInovacaoId, activeEmpresaId],
    queryFn() {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }
      if (!jogadaDeInovacaoId) {
        throw new Error("Ideia não selecionada");
      }

      return getJogadaDeInovacaoItem(activeEmpresaId, jogadaDeInovacaoId);
    },
    select(dataResponse) {
      if (!dataResponse.exists()) {
        return null;
      }

      return subject("TJogadaDeInovacao", dataResponse.data());
    },
    enabled: !!jogadaDeInovacaoId && !!activeEmpresaId
  });
}

export default useGetJogadaDeInovacaoFromUrl;
